export const RATE_VIDEO_REQUEST = Symbol('RATE_VIDEO_REQUEST');
export const RATE_VIDEO_SUCCESS = Symbol('RATE_VIDEO_SUCCESS');

/**
 *
 * @param {string} videoId
 * @param {number} value
 * @return {{type: symbol, payload: {videoId, value}}}
 */
export const rateVideoRequestAction = (videoId, value) => ({
  type: RATE_VIDEO_REQUEST,
  payload: {
    videoId,
    value,
  },
});

export const rateVideoSuccessAction = (averageRating, userRating) => ({
  type: RATE_VIDEO_SUCCESS,
  payload: {
    averageRating,
    userRating,
  },
});
